export const lengthIndicator = (max: number, value?: string): string => {
  return typeof value === 'string' ? `${value.length}/${max}` : `0/${max}`
}
